export const LOGIC_OPERATORS_OPTIONS = [
  {
    value: 'and',
    label: 'all',
  },
  {
    value: 'or',
    label: 'one',
  },
]

export const LOGIC_CONDITIONS_OPTIONS = [
  {
    value: 'in',
    label: 'is',
    inputTypes: ['select', 'boolean'],
  },
  {
    value: 'notIn',
    label: 'is_not',
    inputTypes: ['select', 'boolean'],
  },
  {
    value: 'lt',
    label: 'lt',
    inputTypes: ['number'],
  },
  {
    value: 'lte',
    label: 'lte',
    inputTypes: ['number'],
  },
  {
    value: 'gt',
    label: 'gt',
    inputTypes: ['number'],
  },
  {
    value: 'gte',
    label: 'gte',
    inputTypes: ['number'],
  },
  {
    value: 'eq',
    label: 'eq',
    inputTypes: ['number'],
  },
  {
    value: 'neq',
    label: 'neq',
    inputTypes: ['number'],
  },
]

export const BOOLEAN_INPUT_OPTIONS = [
  {
    value: 'true',
    label: 'true',
  },
  {
    value: 'false',
    label: 'false',
  },
]

export const POPULATE_VALUE_OPTIONS = [
  {
    value: 'true',
    label: 'yes',
  },
  {
    value: 'false',
    label: 'no',
  },
]
